import { render, staticRenderFns } from "./Loginsection.vue?vue&type=template&id=8aa5ee66&"
import script from "./Loginsection.vue?vue&type=script&lang=js&"
export * from "./Loginsection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports